const PROXY_HOSTS = ["cdn.eatzyapp.com", "cdn.eatsy.net", "res.cloudinary.com"];

export function proxyIfCdn(
  url: string | null | undefined,
  _isVideo?: boolean
): string | undefined {
  if (!url) return undefined;
  try {
    const parsed = new URL(url);
    if (PROXY_HOSTS.includes(parsed.hostname)) {
      // CDN files are publicly accessible — serve them directly from the CDN
      // instead of routing through the app-server proxy.  The proxy handlers
      // remain in routes.ts for backward-compat with any external clients.
      return url;
    }
  } catch {
    /* ignore invalid URL */
  }
  return url;
}

export function useAuthenticatedMediaUrl(
  src: string | undefined | null
): string | undefined {
  if (!src) return undefined;
  return proxyIfCdn(src) ?? src;
}

export function useAuthenticatedVideoUrl(
  src: string | undefined | null
): string | undefined {
  if (!src) return undefined;
  return proxyIfCdn(src, true) ?? src;
}
